import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  tableContainer: {
    paddingTop: '2rem',
  },
  modalBody: {
    padding: '1rem',
    overflowY: 'scroll',
  },
  icon: {
    fontSize: 350,
  },
  tableTitle: {
    fontWeight: 500,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid',
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
  },
  optionButtons: {
    minHeight: 30,
    minWidth: 30,
    padding: theme.spacing(0.5),
    '& .MuiButton-label': {
      color: theme.palette.secondary.main,
    },
  },
  optionIcon: {
    fontSize: '1.8rem',
  },
  greenIcon: {
    color: theme.palette.colors.green,
  },
  // Options separator
  separator: {
    display: 'inline-flex',
  },
  multilineCell: {
    display: 'flex',
    flexDirection: 'column',
  },
  modalIframe: {
    width: '100%',
    height: 800,
  },
  simpleForm: {
    '& .MuiGrid-item': {
      padding: theme.spacing(2),
    },
  },
  buttonSuccess: {
    backgroundColor: theme.palette.colors.green,
    display: 'block',
    margin: theme.spacing(1),
  },
  check: {
    color: theme.palette.colors.white,
  },
  buttonResend: {
    margin: '0 1rem 0 auto',
  },
  modalContent: {
    padding: '2rem',
    width: '100%',
    justifyContent: 'center',
    '& p': {
      textAlign: 'justify',
    },
  },
  modalFooter: {
    padding: '0 1.5rem 1.5rem 1.5rem',
    display: 'flex',
    justifyContent: 'flex-end',
    '& button': {
      margin: '0 .5rem',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paginationButton: {
    width: '10%',
    marginTop: '10px',
    marginLeft: '5px',
    marginRight: '5px',
    padding: '8px 18px',
    background: '#f97a00',
    borderRadius: '6px',
    cursor: 'pointer',
    color: 'white',
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'center',

    '&:hover': {
      background: '#e6e6e6',
    },

    '&:active': {
      background: '#c6c6c6',
    },
  },
  paginationText: {
    marginTop: '10px',
    marginLeft: '5px',
    marginRight: '5px',
    padding: '8px 18px',
    color: '#f97a00',
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'center',
  },
  searchButton: {
    background: '#f97a00',
    marginLeft: '10px',
  },
  searchInput: {
    width: '70%',
  },
  icon: {
    fontSize: 350,
  },
  tableTitle: {
    fontWeight: 500,
  },
  container: {
    paddingBottom: 20,
    backgroundColor: theme.palette.colors.white,
  },
}));
